import React from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

import { NavItem } from './types';
import styles from './navbar.scss';
import { useIntl } from 'react-intl';

interface NavbarProps {
  routes: NavItem[];
}

export const Navbar = ({ routes }: NavbarProps) => {
  const intl = useIntl();
  return (
    <header className={styles.header}>
      <nav
        className={clsx(styles.tabNav, styles.mobileNav)}
        style={{ display: 'flex' }}
        aria-label={intl.formatMessage({ id: 'app.navbar.aria_label', defaultMessage: 'App navbar' })}
      >
        {routes.filter(item => !item.hidden).map(item => (
          <NavLink
            key={item.name}
            to={item.url}
            className={({ isActive }) =>
              clsx(styles.tabNavLink, 'uiTypeOtherAction', styles.denseTab, {
                [styles.isActive]: isActive
              })
            }
            style={{ padding: 0, marginRight: 40, border: 'none' }}
          >
            <>
              {item.icon || null}
              {item.name}
            </>
          </NavLink>
        ))}
      </nav>
    </header>
  );
};
